export default __webpack_public_path__ + "static/media/audit-icon.928eb28d.svg";